globalThis.backoffice = globalThis.backoffice || {};

backoffice.PhoneCallQualification = (function() {
  function phoneCallQualification($form) {
    this.config = {
      selectors: {
        ongoingQualification: '.phone-call-qualification-ongoing',
        regainControl: '.regain-control'
      }
    }
    this.$form = $form;
    this.callId = this.$form.data('call-id');
    this.currentWhiteSpaceAgentId = this.$form.data('current-white-space-agent-id');
    this.init();
  }

  phoneCallQualification.prototype = {
    init: function($form) {
      this.initCableSubscription();
      this.initDescriptionCKEditor();
      this.initTranscriptionSummaryCKEditor();
      this.events();
    },
    initCableSubscription: function() {
      const self = this;

      if (typeof globalThis.App == 'undefined') return;

      self.cableSubscription = globalThis.App.cable.subscriptions.create({
        channel: 'IncomingPhoneCallQualificationChannel',
        call_id: self.callId
      }, {
        connected: function() {
          console.log('connected');
          this.perform('check_agent_currently_qualifying', {
            call_id: self.callId
          });
        },
        received: function(data) {
          if(parseInt(data.agent_currently_qualifying_id) != self.currentWhiteSpaceAgentId) {
            if(!self._ongoingQualificationEl().length) {
              $qualificationForm.append(`
                <div class="${self.config.selectors.ongoingQualification.replace(/^\./, '')}">
                  ${data.agent_currently_qualifying_full_name} est en train de qualifier l'appel...<br>
                  <button class="${self.config.selectors.regainControl} btn btn-success btn-sm mt-5">Reprendre la main...</button>
                </div
              `)
            }
          } else {
            self._ongoingQualificationEl().fadeOut('fast');
          }
        },
        disconnected: function() {
          console.log('disconnected');
        }
      });
    },
    initForm: function() {
      backoffice.initSelect2(this.$form.find('.select'));
      backoffice.initSelect2Search($('.select-search'));
      backoffice.initSelect2Ajax(this.$form.find('.select-ajax'));
      this.$form.find('.checkbox-switchery').each(function() { new Switchery($(this).find('input[type=checkbox]')[0]); });
      ContainersToggler.init(this.$form);
      new FormAutosave(this.$form, {
        callbacks: {
          success: function() {
            this.$form.find('.saved').text(`Dernière sauvegarde le ${moment().format('DD/MM/YYYY à HH:mm')}`);
          }
        }
      });
    },
    initDescriptionCKEditor: function() {
      const self = this;
      self.$description = this.$form.find('textarea.description');

      utils.require([assets.ckeditor], function() {
        const editorParams = {
          startupFocus: false,
          enterMode : CKEDITOR.ENTER_BR,
          height: 200,
          skin: 'moono-lisa',
          removePlugins: 'sourcearea,magicline,elementspath',
          toolbar: [
            {
              items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'NumberedList', 'BulletedList', 'HorizontalRule']
            }
          ]
        };
        self.descriptionCKEditor = CKEDITOR.replace(self.$description[0], editorParams);

        self.descriptionCKEditor.on('instanceReady', function(ev){
          ev.editor.dataProcessor.writer.setRules('br', {
            indent : false,
            breakBeforeOpen : false,
            breakAfterOpen : false,
            breakBeforeClose : false,
            breakAfterClose : false
          });
        })
        self.descriptionCKEditor.on('key', function() {
          self.$description.val(self.descriptionCKEditor.getData());
          self.$description.trigger('keyup');
        });
        self.descriptionCKEditor.on('change', function() {
          self.$description.val(self.descriptionCKEditor.getData());
          self.$description.trigger('change');
        });
      });
    },
    initTranscriptionSummaryCKEditor: function() {
      const self = this;
      self.$transcriptionSummary = this.$form.find('textarea.transcription-summary');
      if (!self.$transcriptionSummary.length) return;
      utils.require([assets.ckeditor], function() {
        const editorParams = {
          startupFocus: false,
          enterMode : CKEDITOR.ENTER_BR,
          height: 200,
          skin: 'moono-lisa',
          removePlugins: 'sourcearea,magicline,elementspath',
          toolbar: [
            {
              items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'NumberedList', 'BulletedList', 'HorizontalRule']
            }
          ]
        };
        self.transcriptionSummaryCKEditor = CKEDITOR.replace(self.$transcriptionSummary[0], editorParams);
        self.transcriptionSummaryCKEditor.on('instanceReady', function(ev){
          ev.editor.dataProcessor.writer.setRules('br', {
            indent : false,
            breakBeforeOpen : false,
            breakAfterOpen : false,
            breakBeforeClose : false,
            breakAfterClose : false
          });
        });
        self.transcriptionSummaryCKEditor.on('key', function() {
          self.$transcriptionSummary.val(self.transcriptionSummaryCKEditor.getData());
          self.$transcriptionSummary.trigger('keyup');
        });
        self.transcriptionSummaryCKEditor.on('change', function() {
          self.$transcriptionSummary.val(self.transcriptionSummaryCKEditor.getData());
          self.$transcriptionSummary.trigger('change');
        });
      });
    },
    events: function() {
      const self = this;

      self.$form.on('click', this.config.selectors.regainControl, function(e) {
        e.preventDefault();

        let $button = $(this);

        $button.text('Veuillez patienter...').attr('disabled', true);

        $.post('/incoming_calls/qualification/regain_control', {call_id: self.callId}, function(response) {
          if(response.code) {
            let $newHtml = $(response.html);
            self.destroy(function() {
              self.$form.replaceWith($newHtml)
              let qualification = new phoneCallQualification($(`#${$newHtml.attr('id')}`));
              qualification.initForm();
            });
          }
        });

        return false;
      });

      const $qualificationCallTypeSelect = self.$form.find('select.qualification-call-type');
      const $qualificationOutcome = self.$form.find('.qualification-outcome');
      let currentDescription = self.$description.val();
      let $qualificationCallTypePreviouslySelectedOption = $qualificationCallTypeSelect.find('option:selected');
      let $qualificationCallTypeSelectedOption;

      self.$description.on('change', function() {
        currentDescription = self.$description.val();
      });

      $qualificationCallTypeSelect.on('change', function() {
        if($qualificationOutcome.is(':radio') && !$qualificationOutcome.is(':checked')) return;
        if($qualificationOutcome.val() != 'connected') return;

        $qualificationCallTypeSelectedOption = $qualificationCallTypeSelect.find('option:selected');
        let descriptionTemplate = $qualificationCallTypeSelectedOption.data('description-template');

        if(currentDescription == '' || $qualificationCallTypePreviouslySelectedOption.data('description-template') == currentDescription) {
          self.descriptionCKEditor.setData(descriptionTemplate);
        } else if(descriptionTemplate) {
          self.descriptionCKEditor.setData(`${currentDescription}<br>------<br>${descriptionTemplate}`);
        }

        currentDescription = self.$description.val();
        $qualificationCallTypePreviouslySelectedOption = $qualificationCallTypeSelectedOption;
      });
    },
    destroy: function(callback) {
      const self = this;
      App.cable.subscriptions.remove(self.cableSubscription);
      self.$form.fadeOut('fast', function() {
        if(typeof callback == 'function') callback();
        self.$form.remove();
      });
    },
    _ongoingQualificationEl: function() {
      return this.$form.find(this.config.selectors.ongoingQualification);
    }
  }

  return phoneCallQualification;
})();
